"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fields = Fields;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cssModifierUtilities = require("../utilities/cssModifierUtilities");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Fields(_ref) {
  var children = _ref.children,
      cssClassModifiers = _ref.cssClassModifiers;
  var className = (0, _cssModifierUtilities.buildClassName)('fields', cssClassModifiers);
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: className
    }, children)
  );
}

Fields.propTypes = {
  children: _propTypes["default"].node.isRequired,
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
Fields.defaultProps = {
  cssClassModifiers: []
};